<section id="login" class="panel-container">
  <div class="panel-header">
    <h2 class="title">
      {{ 'Auth.Login.Title' | translate }}
    </h2>
  </div>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div class="panel-body">
      <div class="input-group account">
        <input
          id="account"
          class="input"
          [ngClass]="{ invalid: !!loginError || isAccountError }"
          formControlName="account"
          [placeholder]="'Auth.Login.Field.Account' | translate"
        />
      </div>

      <div class="input-group password">
        <input
          id="password"
          class="input"
          [ngClass]="{ invalid: !!loginError || isPasswordError }"
          type="password"
          formControlName="password"
          [placeholder]="'Auth.Login.Field.Password' | translate"
        />
      </div>

      <p id="error-msg" *ngIf="loginErrorMsg" class="invalid-msg">
        <i class="icon-danger"></i>
        {{ loginErrorMsg | translate }}
      </p>

      <div class="input-group" *ngIf="isAllowRememberMe">
        <label class="remember-me"
          >{{ 'Auth.Login.RememberMe' | translate }}
          <input
            type="checkbox"
            class="checkbox"
            id="remember-me"
            formControlName="rememberMe"
          />
          <span class="mark"></span>
        </label>
      </div>
    </div>

    <div class="panel-footer">
      <button id="submit-btn" class="button" type="submit">
        <div class="darken-shape">
          {{ 'Auth.Login.Button.Confirm' | translate }}
        </div>
      </button>
    </div>
  </form>
</section>
